import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {BackendResponseType} from "@/types/page-response";


export type ErrorState = Omit<BackendResponseType, "status">

const initialState: ErrorState = {
    errorMessage: null
}

export const errorSlice = createSlice({
    name: 'messenger',
    initialState,
    reducers: {
        setError: (state, action: PayloadAction<ErrorState>) => {
            state.errorMessage = action.payload?.errorMessage;
            state.errorCode = action.payload?.errorCode;
            state.errorLevel = action.payload?.errorLevel;
        },
        clearError: (state) => {
            state.errorMessage = null;
            state.errorCode = undefined;
            state.errorLevel = undefined;
        }
    }
})

export const {
    setError,
    clearError
} = errorSlice.actions

const errorReducer = errorSlice.reducer
export default errorReducer